export const home = {
  heroTitle1: "USFansSpreadsheet",
  heroTitle2: "Kompletny przewodnik",
  heroTitle3: "2026",
  heroSubtitle: "Poznaj USFansSpreadsheet, sprawdź funkcje, porównania, bezpieczeństwo oraz najnowsze poradniki krok po kroku.",
  whatIsLabel: "Co to jest USFansSpreadsheet?",
  whatIsTitle1: "Kompletny przewodnik",
  whatIsTitle2: "aktualizacje i recenzje",
  whatIsTitle3: "narzędzia online",
  trust1: "Aktualizowane poradniki",
  trust2: "Szczegółowe porównania",
  trust3: "Instrukcje krok po kroku",
  trust4: "Informacje o bezpieczeństwie",
  trust5: "Regularne aktualizacje",
  categoriesTitle1: "Kategorie",
  categoriesTitle2: "Produktów",
  allCategories: "Wszystkie kategorie",
  discoverTitle1: "Poznaj pełną",
  discoverTitle2: "ofertę USFansSpreadsheet",
  ctaShopLabel: "Oficjalny sklep",
  ctaShopTitle1: "USFans",
  ctaShopTitle2: "Spreadsheet",
  ctaShopTitle3: "2026",
  ctaBuyTitle1: "Kup teraz",
  ctaBuyTitle2: "w oficjalnym sklepie",
  ctaBuyDesc: "Odwiedź oficjalny sklep USFansSpreadsheet i odkryj pełną kolekcję produktów. Najlepsze ceny, szybka wysyłka i gwarancja jakości.",
  articleLabel: "(Najnowszy artykuł SEO)",
  articleTitle1: "USFansSpreadsheet Review 2026",
  articleTitle2: "Zalety, wady i opinie",
  articleAuthor: "Ekspert ds. narzędzi online",
  readArticle: "Przeczytaj artykuł",
  featuresTitle: "Funkcje USFansSpreadsheet",
  features: [
    "Intuicyjny interfejs użytkownika",
    "Zaawansowane filtrowanie danych",
    "Eksport do wielu formatów",
    "Integracja z popularnymi platformami",
    "Automatyczne aktualizacje",
    "Wsparcie techniczne 24/7",
  ],
  safetyTitle: "Czy USFansSpreadsheet jest bezpieczny?",
  safetyDesc: "Bezpieczeństwo jest naszym priorytetem. USFansSpreadsheet przechodzi regularne audyty bezpieczeństwa i wykorzystuje zaawansowane szyfrowanie danych. Wszystkie transakcje są chronione, a dane użytkowników nigdy nie są udostępniane stronom trzecim.",
  safetyItems: [
    "Szyfrowanie end-to-end",
    "Regularne audyty bezpieczeństwa",
    "Zgodność z RODO",
    "Dwuskładnikowe uwierzytelnianie",
  ],
  faqTitle: "Często zadawane pytania",
  updatesTitle: "Aktualizacje 2026",
  footerDesc: "USFansSpreadsheet to kompleksowe źródło informacji, poradników i recenzji. Naszym celem jest dostarczanie najbardziej aktualnych i rzetelnych informacji.",
};